(() => {
  function initialize(root) {
    root.querySelectorAll('[data-coco-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-carousel-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const previous = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      const toggle = carousel.querySelector('[data-carousel-pause]');
      const count = carousel.querySelector('[data-carousel-count]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timer = null;
      let playing = false;
      let scheduled = false;
      function currentIndex() {
        const step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step)));
      }
      function update() {
        count.textContent = String(currentIndex() + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }
      function move(direction, wrap) {
        const step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
        let left = track.scrollLeft + direction * step;
        if (wrap && left > track.scrollWidth - track.clientWidth + 2) left = 0;
        track.scrollTo({left, behavior: reduced.matches ? 'auto' : 'smooth'});
      }
      function stop() {
        clearInterval(timer);
        timer = null;
        playing = false;
        toggle.textContent = toggle.dataset.playLabel;
        toggle.setAttribute('aria-label', toggle.dataset.playLabel);
        toggle.setAttribute('aria-pressed', 'false');
      }
      function play() {
        stop();
        playing = true;
        toggle.textContent = toggle.dataset.pauseLabel;
        toggle.setAttribute('aria-label', toggle.dataset.pauseLabel);
        toggle.setAttribute('aria-pressed', 'true');
        timer = setInterval(() => {
          if (!carousel.isConnected) return stop();
          if (document.hidden || track.matches(':hover') || track.contains(document.activeElement)) return;
          move(1, true);
        }, 7000);
      }
      previous.addEventListener('click', () => { stop(); move(-1, false); });
      next.addEventListener('click', () => { stop(); move(1, false); });
      toggle.addEventListener('click', () => playing ? stop() : play());
      track.addEventListener('pointerdown', stop, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); stop(); move(event.key === 'ArrowRight' ? 1 : -1, false);
      });
      track.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { update(); scheduled = false; });
      }, {passive: true});
      new ResizeObserver(update).observe(track);
      reduced.addEventListener('change', () => { if (reduced.matches) stop(); });
      update();
    });
    root.querySelectorAll('[data-coco-edit]').forEach(edit => {
      if (edit.dataset.ready) return;
      edit.dataset.ready = 'true';
      const tabs = Array.from(edit.querySelectorAll('[role="tab"]'));
      const panels = Array.from(edit.querySelectorAll('[role="tabpanel"]'));
      function activate(tab, focus) {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next], true);
        });
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
